module.exports = __webpack_public_path__ + "img/masks-selection.f1860233.jpg";